import PropTypes from 'prop-types'
import Error from '../../ui/Error'
import ModalDescripcionPlan from './modals/ModalDescripcionPlan'
import ModalPeriodicidadPago from './modals/ModalPeriodicidadPago'
import ModalTipoPlan from './modals/ModalTipoPlan'

const Opciones = ({
  errores,
  tienda,
  setTienda,
  planes,
  periodicidades,
  tiendaBD,
  nuevoPlan,
  setNuevoPlan
}) => {
  return (
    <div className="col-12 col-lg">
      <h3>Opciones</h3>
      <div className="ml-2">
        <ul>
          <Error name="modalPlan" errores={errores}>
            <ModalTipoPlan
              planes={planes}
              tienda={tienda}
              setTienda={setTienda}
              nuevoPlan={nuevoPlan}
              setNuevoPlan={setNuevoPlan}
            />
          </Error>
          <Error name="modalPeriodicidad" errores={errores}>
            <ModalPeriodicidadPago
              periodicidades={periodicidades}
              tienda={tienda}
              setTienda={setTienda}
              tiendaBD={tiendaBD}
            />
          </Error>
          <ModalDescripcionPlan tienda={tienda} />
        </ul>
      </div>
    </div>
  )
}

Opciones.propTypes = {
  errores: PropTypes.object,
  tienda: PropTypes.shape({
    idTiendaOficialPlan: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    nombre: PropTypes.string,
    idTiendaOficialPeriodicidad: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    nombrePeriodicidad: PropTypes.string
  }).isRequired,
  setTienda: PropTypes.func.isRequired,
  planes: PropTypes.arrayOf(PropTypes.object).isRequired,
  periodicidades: PropTypes.arrayOf(PropTypes.object).isRequired,
  tiendaBD: PropTypes.shape({
    idTiendaOficialPeriodicidad: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    nombrePeriodicidad: PropTypes.string
  }).isRequired,
  nuevoPlan: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setNuevoPlan: PropTypes.func.isRequired
}

export default Opciones
